import styled from "styled-components";
import { safeAreaInset } from "@lib/telegram";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 12px;
  gap: 8px;
  overflow-y: auto;
  height: 100%;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex: 0;
`;

export const BottomSheetContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 8px;
  padding-bottom: ${safeAreaInset().bottom === 0 ? 16 : safeAreaInset().bottom - 8}px;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 16px;
  padding-bottom: ${safeAreaInset().bottom === 0 ? 16 : safeAreaInset().bottom + 4}px;
`;
